import React from 'react';

interface UploadProfilePreviewProps {
  data: number[];
  label?: string;
  color?: string;
}

const HOUR_LABELS = [0, 6, 12, 18, 23];
const W = 240;
const H = 60;
const PAD_L = 18;
const PAD_B = 14;
const BAR_GAP = 1;

export const UploadProfilePreview: React.FC<UploadProfilePreviewProps> = ({
  data,
  label,
  color = 'hsl(var(--primary))',
}) => {
  const max = Math.max(...data, 0.001);
  const barW = (W - PAD_L - data.length * BAR_GAP) / data.length;
  const chartH = H - PAD_B;

  return (
    <div className="mt-2">
      {label && <div className="text-[9px] text-muted-foreground mb-1 font-medium">{label}</div>}
      <svg width={W} height={H} className="block" viewBox={`0 0 ${W} ${H}`}>
        {data.map((v, i) => {
          const barH = (v / max) * chartH;
          const x = PAD_L + i * (barW + BAR_GAP);
          const y = chartH - barH;
          return (
            <rect
              key={i}
              x={x}
              y={y}
              width={barW}
              height={barH}
              fill={color}
              opacity={0.8}
              rx={1}
            />
          );
        })}
        {/* X axis labels */}
        {HOUR_LABELS.map(h => {
          const x = PAD_L + h * (barW + BAR_GAP) + barW / 2;
          return (
            <text key={h} x={x} y={H - 1} textAnchor="middle" className="fill-muted-foreground" fontSize={7}>
              {h}h
            </text>
          );
        })}
        {/* Y axis: peak */}
        <text x={PAD_L - 2} y={8} textAnchor="end" className="fill-muted-foreground" fontSize={7}>
          {max.toFixed(1)}
        </text>
      </svg>
    </div>
  );
};
